import React from 'react';
import {SideMenuProps} from './types';
import styled from 'styled-components';
import {scrollBarStyling} from '../styles';
import {Size} from '../types';
import {useDimensionsRef} from 'rooks';

const Wrapper = styled.div`
  padding: 8px 0;
  width: 100%;
  box-sizing: border-box;
  flex-flow: column;
  display: flex;
  flex: 1;
  overflow: hidden;
`;

const ScrollableContainer = styled.div`
  flex: 1;
  display: flex;
  overflow-y: auto;
  max-height: 100%;

  &.scrollable {
    margin-right: 6px;
    padding-right: 6px;
  }

  ${scrollBarStyling(Size.Small)}
`;


export const SideMenuBody = (props: SideMenuProps) => {
  const [scrollable, setScrollable] = React.useState(false);
  const [ref, dimensions, node] = useDimensionsRef({updateOnResize: true});

  React.useEffect(() => {
    const clientHeight = node?.clientHeight ?? 0;
    const scrollHeight = node?.scrollHeight ?? 0;
    setScrollable(scrollHeight > clientHeight);
  }, [dimensions, node, props.children]);

  return (
    <Wrapper>
      <ScrollableContainer ref={ref as any}
                           className={scrollable ? 'scrollable' : ''}>
        {props.children}
      </ScrollableContainer>
    </Wrapper>
  )
};
